export default __webpack_public_path__ + "static/media/Dmitry.9ceea631.png";